import { render, staticRenderFns } from "./files-dialog.vue?vue&type=template&id=fa9fb526&scoped=true"
import script from "./files-dialog.vue?vue&type=script&lang=js"
export * from "./files-dialog.vue?vue&type=script&lang=js"
import style0 from "./files-dialog.vue?vue&type=style&index=0&id=fa9fb526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9fb526",
  null
  
)

export default component.exports